import { ColorsType } from "../types/styles.types";

export const COLORS: ColorsType = {
  MainBlue: '#3070A0',
  LightBlue: '#42ABD9',
  LightFont: '#6B7280',
  LightHeader: '#111827',
  LightGrey: '#E2E4E8',
  PaleBlue: '#E9F7FE',
  DarkBlue: '#1D293F',
  DarkBlue2: '#051129',
  DarkBlue3: '#020B24',
  DarkBlue4: '#0b193D',
  White: '#FFFFFF',
  FadedWhite: '#e6e6e6',
  LightBackground: '#f9fafa',
  LightButton: '#3493C5'
};
